import React, { memo } from "react";
import "./styles.scss";
import FaMapMarkerAlt from "../../constants/icons/Fa/FaMapMarkerAlt";
import FaBookmark from "../../constants/icons/Fa/FaBookmark";
import { useDispatch } from "react-redux";
import {
  setCurrentQuestionIndex,
  setReviewMode,
} from "../../store/fullLengthExam";
import { Modal } from "react-bootstrap";


function ReviewScreen({
  sectionQuestions,
  markedQuestions,
  userAnswers,
  currentQuestionIndex,
  reviewMode = false,
  currentSectionIndex,
  isInModal = false,
  failAttempt = false,
  isErrorModalOpen = false,
  setIsErrorModalOpen,
}) {
  // Calculate the current section and module numbers
  const dispatch = useDispatch();
  const currentSectionNumber = Math.floor(currentSectionIndex / 2) + 1;
  const currentModuleNumber = (currentSectionIndex % 2) + 1;

  const handleQuestionClick = (index) => {
    if(failAttempt) {
      return
    }
    dispatch(setCurrentQuestionIndex(index));
    dispatch(setReviewMode(false));
  };

  // Ensure this function correctly checks if the question at the given index in the current section has an answer
  const isQuestionAnswered = (questionIndex) => {
    return (
      userAnswers[currentSectionIndex] &&
      userAnswers[currentSectionIndex][questionIndex] &&
      userAnswers[currentSectionIndex][questionIndex] !== null &&
      userAnswers[currentSectionIndex][questionIndex]?.answer
    );
  };

  return (
    <div
      className={`container text-center pt-5 ${isInModal ? "mt-0" : "mt-5"}`}
      id="reviewScreen"
      style={{
        minWidth: "565px",
        maxWidth: "600px",
      }}
    >
      {reviewMode && (
        <>
          <h3>Check Your Work</h3>
          <b style={{ fontSize: "14px" }}>
            On test day, you won’t be able to move on to the next module until
            time expires. For these practice questions, you can click Next when
            you’re ready to move on.
          </b>
        </>
      )}
        {isErrorModalOpen && (
          <Modal show={isErrorModalOpen} onHide={setIsErrorModalOpen} centered>
            <Modal.Header closeButton>
              <Modal.Title>      <div className='d-flex align-items-center' style={{gap: '12px'}}> <div
              className="d-flex align-items-center justify-content-center rounded-circle"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 9v4m0 4h.01M10.29 3.86l-8.18 14.18A1.5 1.5 0 0 0 3.5 20.5h17a1.5 1.5 0 0 0 1.39-2.46L13.71 3.86a1.5 1.5 0 0 0-2.42 0z"
                  stroke="#B4761F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div> Don&apos;t refresh this screen</div></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p
                id="exam-warning-desc"
                className="mb-0 text-secondary text-center"
                style={{ fontSize: 14.5, lineHeight: 1.6 }}
              >
                Your connection was interrupted. Please check your internet connection —
                refreshing or closing this page now may erase your saved exam progress.
                Once your connection is back, click <strong className="text-dark">Next</strong> to
                continue submitting your exam.
              </p>
            </Modal.Body>
          </Modal>
        )}
      <div className="row justify-content-center">
        <div
          className="col text-center p-3"
          style={{ border: "1px solid black", borderRadius: "10px" }}
        >
          <div className="row mb-4">
            <div className="col">
              <b className="mb-0">
                Section {currentSectionNumber}, Module {currentModuleNumber}:
                Reading and Writing
              </b>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col d-flex justify-content-center align-items-center">
              <FaMapMarkerAlt className="me-2" />
              <span className="me-3">Current</span>
              <div
                className="p-2 me-2"
                style={{
                  border: "1px dashed grey",
                }}
              ></div>
              <span className="me-3">Unanswered</span>
              <FaBookmark className="me-2" />
              <span>For review</span>
            </div>
          </div>
          <div className="row">
            {sectionQuestions?.map((question, index) => (
              <div
                key={index}
                className="col-2 mb-3 question-number"
                style={{ cursor: "pointer" }}
                onClick={() => handleQuestionClick(index)}
              >
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    position: "relative",
                    backgroundColor: isQuestionAnswered(index)
                      ? "#314CC6"
                      : markedQuestions?.includes(question?._id)
                      ? "rgb(255, 248, 225)"
                      : "rgb(255, 255, 255)",
                    color: isQuestionAnswered(index) ? "white" : "rgb(0, 0, 0)",
                    border: "1px dashed rgb(214, 188, 188)",
                    borderRadius: "2px",
                    padding: "5px",
                    maxWidth: "33px",
                  }}
                >
                  {currentQuestionIndex === index && (
                    <FaMapMarkerAlt
                      className="position-absolute"
                      style={{ color: "black", top: "-15px" }}
                    />
                  )}
                  {markedQuestions?.includes(question?._id) && (
                    <FaBookmark
                      className="position-absolute"
                      style={{ color: "red", top: "-10px", right: "-10px" }}
                    />
                  )}
                  <h6 className="mb-0">{index + 1}</h6>
                </div>
              </div>
            ))}
          </div>
          {/* Add a button at the end of the review screen */}
          {/* <div className="row">
            <div className="col mt-3">
              <Button variant="primary" onClick={onGoToReviewScreen}
              >
                Go to Review Screen
              </Button>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default memo(ReviewScreen);
